import { formatOriginalPrice } from '@/domain/price'

import { type ListingPriceAmount } from './GetPriceLabelValue'

/**
 * Renders a shopping ads price label. Displays price if available, otherwise displays nothing.
 *
 * @param {Object} params The function parameters.
 * @param {Object} params.amount The price amount to be displayed.
 * @param {boolean} [params.isFrench] A flag indicating if the price should be formatted for French locale (optional).
 * @returns {JSX.Element | null} The rendered price label component or null if the price amount is 0.
 */
const FixedPriceAmount = ({ price, isFrench }: ListingPriceAmount) => {
  return (
    <>
      {price && (
        <span data-testid="shopping-ads-fixed-amount">
          {formatOriginalPrice(price, {
            isFrench,
          })}
        </span>
      )}
    </>
  )
}

export default FixedPriceAmount
